import { defineStore } from 'pinia';
import { ExternalPatientReferenceTypeService } from '@/services/api';
import { UHB_NHS_NUMBER_KEY } from '@/constants';
const externalPatientReferenceTypeService = new ExternalPatientReferenceTypeService();
export const usePatientStore = defineStore('patient', {
    state: () => ({
        externalPatientReferenceTypes: []
    }),
    actions: {
        async fetchExternalPatientReferenceTypes() {
            this.externalPatientReferenceTypes = (await externalPatientReferenceTypeService.index()).data;
        }
    },
    getters: {
        showNhsNumber() {
            return !!this.externalPatientReferenceTypes.find((type) => type.key === UHB_NHS_NUMBER_KEY);
        }
    }
});
